import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-compact-footer',
  imports: [TranslatePipe],
  templateUrl: './compact-footer.component.html',
  styleUrl: './compact-footer.component.scss',
})
export class CompactFooter {
  readonly currentYear = new Date().getFullYear();

  readonly companyInfoLinks = [
    { textKey: 'footer.CAREERS', url: 'https://www.myrocketcareer.com/' },
    { textKey: 'footer.CONTACT_US', url: 'https://www.rocketclose.com/contact' },
    { textKey: 'footer.BLOG', url: 'https://www.rocketclose.com/blog' },
  ];

  readonly siteUseLinks = [
    { textKey: 'footer.TERMS_OF_USE', url: 'https://www.rocketclose.com/terms-of-use' },
    { textKey: 'footer.PRIVACY_POLICY', url: 'https://www.rocketclose.com/privacy-policy' },
    { textKey: 'footer.DISCLOSURES', url: 'https://www.rocketclose.com/disclosures-licenses' },
    { textKey: 'footer.SOLUTIONS', url: 'https://www.rocketclose.com/solutions' },
  ];

  readonly socialLinks = [
    { name: 'Facebook', icon: 'assets/icons/facebook-default.svg', url: 'https://www.facebook.com/RocketClose' },
    { name: 'Instagram', icon: 'assets/icons/instagram-default.svg', url: 'https://www.instagram.com/rocketclose/' },
    { name: 'LinkedIn', icon: 'assets/icons/linkedin-default.svg', url: 'https://www.linkedin.com/company/rocketclose' },
  ];
}
